import { useState, useCallback } from 'react'
import { backfillService } from '../services/backfillService'
import type { BackfillPreviewResponse } from '../types'
import axios from 'axios'

export function useBackfillPreview() {
  const [preview, setPreview] = useState<BackfillPreviewResponse | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchPreview = useCallback(async (category: string, ruleIds: number[]) => {
    setIsLoading(true)
    setError(null)
    try {
      const data = await backfillService.preview({ category, rule_ids: ruleIds })
      setPreview(data)
    } catch (err) {
      if (axios.isAxiosError(err)) {
        setError(err.response?.data?.detail || 'Error al generar preview')
      } else {
        setError('Error inesperado')
      }
      setPreview(null)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const reset = useCallback(() => {
    setPreview(null)
    setError(null)
  }, [])

  return { preview, isLoading, error, fetchPreview, reset }
}
